import React from "react";
import { Flex, Switch, Typography } from "antd";
import {
  MailOutlined,
  WhatsAppOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";

interface NotificationsSectionProps {
  notifications?: {
    email: boolean;
    whatsapp: boolean;
  };
  themeColor?: string;
}

const NotificationsSection: React.FC<NotificationsSectionProps> = ({
  notifications,
  themeColor,
}) => {

  const items = [
    {
      key: "email",
      icon: <MailOutlined style={{ color: themeColor || "#1890ff", fontSize: 16, marginTop: 2 }} />,
      label: "Email",
      enabled: notifications?.email ,
    },
    {
      key: "whatsapp",
      icon: <WhatsAppOutlined style={{ color: themeColor || "#1890ff", fontSize: 16, marginTop: 2 }} />,
      label: "WhatsApp",
      enabled: notifications?.whatsapp,
    },
  ];

  return (
    <Flex gap={24} wrap="wrap">
      {items.map((item) => (
        <div key={item.key} className="stat-item">
          <div className="stat-content">
            <Flex vertical gap={4}>
              <Typography.Text type="secondary" className="stat-label">
                <Flex align="center" gap={8}>
                  {item.icon}
                  {item.label}
                </Flex>
              </Typography.Text>
              <Flex align="center" gap={4}>
                {/* {item.enabled ? (
                <CheckCircleFilled style={{ color: "#52c41a", fontSize: 12 }} />

              ) : (
                <CloseCircleFilled style={{ color: "#ff4d4f", fontSize: 12 }} />

              )} */}
                <Switch
                  checked={item?.enabled === true}                  
                  disabled
                  loading={item?.enabled === null}
                />
                {/* <Typography.Text strong className="stat-value">
                {item.enabled ? "Enableds" : "Disabled"}
              </Typography.Text> */}
              </Flex>
            </Flex>
          </div>
        </div>
      ))} 
    </Flex>
  );
};

export default NotificationsSection;
